import { util, shapes } from '@clientio/rappid';
import { MessageAttributes } from './message.attributes';

export class MessageShape extends shapes.standard.Rectangle {
  defaults(): object {
    return util.defaultsDeep(MessageAttributes, shapes.standard.Rectangle.prototype.defaults);
  }
}
